import LazyLoad from 'vanilla-lazyload';
import $ from 'jquery';

$(function () {
	new LazyLoad();
} );